export default __webpack_public_path__ + "static/media/impostor-win.a3cf6271.mp3";